"use strict";

import React, { Component, PropTypes } from "react";

/******************************************************************************
** ErrorMessage
*/

export default class ErrorMessage extends Component {

	render() {
		return (
				<div>{this.props.children}</div>
			);
	}

}



/** WEBPACK FOOTER **
 ** ./forms/ErrorMessage.jsx
 **/